import { render, staticRenderFns } from "./ModelConfig.vue?vue&type=template&id=0a5bd55e"
import script from "./ModelConfig.vue?vue&type=script&lang=js"
export * from "./ModelConfig.vue?vue&type=script&lang=js"
import style0 from "./ModelConfig.vue?vue&type=style&index=0&id=0a5bd55e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports